<script setup lang="ts">
</script>
<template>
  <div class="footer">
  </div>
</template>
<style scoped>
.footer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
